import { Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import { ProjectElementNodeWithMetadata } from 'api/graphQL/types/projectElement.types'
import { useWorkspace2ActionBarStyles } from 'components/WorkspaceEditor/styles/useWorkspace2ActionBarStyles'
import React, { useMemo } from 'react'
import { formatLocalDateTime } from 'shared/utils/dateUtils'
interface ProjectInfoProps {
    projectName: string
    selectedProjectNode: ProjectElementNodeWithMetadata
}
const ProjectInfo = ({
    projectName,
    selectedProjectNode,
}: ProjectInfoProps) => {
    const { projectTitle, lastSavedLabel } = useWorkspace2ActionBarStyles({
        isOMorSMM: true,
    })
    const lastSavedText = useMemo(() => {
        const modifiedBy =
            selectedProjectNode?.metadata?.modifiedBy?.profileInfo
        const lastUpdated = selectedProjectNode?.metadata?.updated
        if (modifiedBy && lastUpdated)
            return selectedProjectNode?.isInProject
                ? `LAST SAVED: ${formatLocalDateTime(
                      new Date(lastUpdated),
                      'MMMM DD, yyyy, HH:mm'
                  )} UTC - ${modifiedBy?.firstName} ${modifiedBy?.lastName}`
                : ''
        return ''
    }, [selectedProjectNode])

    return (
        <>
            <Typography className={projectTitle}>{projectName}</Typography>
            {lastSavedText && (
                <Typography className={lastSavedLabel}>
                    <RefreshIcon fontSize="inherit" />
                    {lastSavedText}
                </Typography>
            )}
        </>
    )
}
export default ProjectInfo
